import { render, staticRenderFns } from "./orderWxshenpi.vue?vue&type=template&id=5ada5262&scoped=true"
import script from "./orderWxshenpi.vue?vue&type=script&lang=js"
export * from "./orderWxshenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxshenpi.vue?vue&type=style&index=0&id=5ada5262&prod&scoped=true&lang=css"
import style1 from "./orderWxshenpi.vue?vue&type=style&index=1&id=5ada5262&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada5262",
  null
  
)

export default component.exports